import { DomeComponent, DomeManipulator, React } from "@lexriver/dome";
import { GlobalState } from "../GlobalState";
import css from './LeftSidebar.m.scss';


import { EnumIconNames } from "../enums/EnumIconNames";
import { GlobalLeftSidebar } from "../GlobalLeftSidebar";
import { ServerMenu } from "../server-queries/ServerMenu";
import { LoadingSpinnerForPage } from "./LoadingSpinnerForPage";
import { MenuItem } from "./MenuItem";
import { UserInMenu } from "./UserInMenu";

const filename = 'LeftSidebar'

interface Attrs{

}

export class LeftSidebar extends DomeComponent<Attrs>{
    //sidebarWidth:number = 0
    refBackdrop!:HTMLDivElement
    refSidebar!:HTMLDivElement
    refMenuContainer!:HTMLDivElement
    refMenuItems!:HTMLDivElement
    render(){
        return (
            <>
            <div class={css.sidebar} ref={ref => this.refSidebar = ref}>
                {/* <a href="javascript:void(0)" class={css.buttonClose} onclick={() => GlobalState.onSidebarEvent.triggerAsync(false)}>&times;</a> */}
                <div ref={ref => this.refMenuContainer = ref} class={css.menuItems}>
                    <div class={css.buttonClose} onClick={() => GlobalLeftSidebar.eventOnHide.triggerAsync()}>
                        <span class={EnumIconNames.Cancel} />
                    </div>
                    <UserInMenu />
                    <div ref={ref => this.refMenuItems = ref}>
                        <LoadingSpinnerForPage />
                    </div>
                    {/* <div class={css.desktopVersionContainer}>
                        <a href="/home">версия для компьютера</a>
                    </div> */}
                    
                </div>
            </div>            
            <div class={css.backdrop} ref={ref => this.refBackdrop = ref} onClick={() => GlobalLeftSidebar.eventOnHide.triggerAsync()}></div>
            </>
        )
    }

    

    async afterRender(){
        GlobalLeftSidebar.eventOnHide.subscribe(() => {
            //console.log(filename, 'eventOnHide')
            //this.sidebar.style.opacity = '0.5'
            // this.refSidebar.style.transitionDuration = Settings.sidebarTransitionDuration
            // this.refSidebar.style.width = '0'
            this.hide()
        })

        GlobalLeftSidebar.eventOnShow.subscribe(() => {
            //console.log(filename, 'eventOnShow')
            //this.sidebar.style.opacity = '1'
            // this.refSidebar.style.transitionDuration = Settings.sidebarTransitionDuration
            // this.refSidebar.style.width = Settings.sidebarWidth+'px'
            this.show()
        })

        await this.populateMenuAsync()
        // GlobalLeftSidebar.eventOnMove.subscribe((x) => {
        //     this.sidebar.style.transitionDuration = '0s'
        //     this.sidebar.style.width = x <= Settings.sidebarWidth ? x+'px' : Settings.sidebarWidth+'px'
        // })

        GlobalState.eventPageChange.subscribe(async () => {
            await GlobalLeftSidebar.hideAsync()
        })
        
    }

    protected show(){
        this.refSidebar.classList.add(css.sidebarOpen)
        this.refBackdrop.classList.add(css.backdropVisible)
    }

    protected hide(){
        this.refSidebar.classList.remove(css.sidebarOpen)
        this.refBackdrop.classList.remove(css.backdropVisible)
    }

    async populateMenuAsync() {
        try {
            const topLevelItems = await ServerMenu.getTopLevelItemsSortedAsync()
            if (!topLevelItems) throw new Error('unable to get topLevelItems')
            //console.log('topLevelItems=', topLevelItems)
            await DomeManipulator.replaceAllChildrenAsync(this.refMenuItems,
                <nav role="navigation">
                    {topLevelItems.map((item) => <MenuItem jsonMenuItem={item} />)}
                </nav>)

        } catch (x) {
            console.error('query `topmenuitems` failed', x)
        }

    }

}